import React, { ChangeEvent, useState } from "react";
import { SearchBarWrapper, SearchInput, IconButton } from "./SearchBar.styles";
import { CiSearch } from "react-icons/ci";
import { AiOutlineClose } from "react-icons/ai";

const SearchBar = ({
  onSearch,
}: {
  onSearch: (searchItem: string) => void;
}) => {
  const [isActive, setIsActive] = useState(false);
  const [searchItem, setSearchItem] = useState("");

  const clearSearch = () => {
    setSearchItem("");
    onSearch("");
  };

  const handleSearchItem = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchItem(value);
    onSearch(value);
  };

  return (
    <SearchBarWrapper>
      <IconButton>
        {searchItem ? <AiOutlineClose onClick={clearSearch} /> : <CiSearch />}
      </IconButton>
      <SearchInput
        placeholder="Search history by date, amount, or description"
        value={searchItem}
        onChange={handleSearchItem}
      />
    </SearchBarWrapper>
  );
};

export default SearchBar;
